import { render } from "./ArrayChoicesTypeComponent.vue?vue&type=template&id=b8f7c666&scoped=true"
import script from "./ArrayChoicesTypeComponent.vue?vue&type=script&lang=js"
export * from "./ArrayChoicesTypeComponent.vue?vue&type=script&lang=js"

import "./ArrayChoicesTypeComponent.vue?vue&type=style&index=0&id=b8f7c666&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8f7c666"]])

export default __exports__